export default function ScheduleCiqIcon({
  size = 12,
  className = "fill-black",
  opacity = "0.6"
}: {
  size?: number;
  className?: string;
  opacity?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.91667 0.166748V1.33341H10.6705C10.9905 1.33341 11.25 1.59297 11.25 1.9129V11.2539C11.25 11.5739 10.9905 11.8334 10.6705 11.8334H1.32948C1.00944 11.8334 0.75 11.5739 0.75 11.2539V1.9129C0.75 1.59286 1.00955 1.33341 1.32948 1.33341H3.08333V0.166748H8.91667ZM3.08333 2.50008H1.91667V10.6667H10.0833V2.50008H8.91667V3.66675H3.08333V2.50008ZM4.25 8.33342V9.50008H3.08333V8.33342H4.25ZM4.25 6.58342V7.75008H3.08333V6.58342H4.25ZM4.25 4.83342V6.00008H3.08333V4.83342H4.25ZM7.75 1.33341H4.25V2.50008H7.75V1.33341Z"
        fill="current"
        fillOpacity={opacity}
      />
    </svg>
  );
}

/**
 * Schedules badge — clipboard on its fixed-colour tile.
 * Design: 36×36 container (#FFB64F) + glyph (#B85C16). Used by CiqIconBox.
 */
export function ScheduleTileCiqIcon({
  size = 36,
  className = ""
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="36" height="36" rx="4" fill="#FFB64F" />
      <path
        d="M22.7778 7V9.1H25.9514C26.5305 9.1 27 9.5672 27 10.1431V26.9569C27 27.533 26.5304 28 25.9514 28H9.04859C8.46947 28 8 27.5329 8 26.9569V10.1431C8 9.567 8.46967 9.1 9.04859 9.1H12.2222V7H22.7778ZM12.2222 11.2H10.1111V25.9H24.8889V11.2H22.7778V13.3H12.2222V11.2ZM14.3333 21.7V23.8H12.2222V21.7H14.3333ZM14.3333 18.55V20.65H12.2222V18.55H14.3333ZM14.3333 15.4V17.5H12.2222V15.4H14.3333ZM20.6667 9.1H14.3333V11.2H20.6667V9.1Z"
        fill="#B85C16"
      />
    </svg>
  );
}
